const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/

export const toDateInputValue = (dateStr: string | null | undefined): string => {
    if (!dateStr) return ''

    const match = dateStr.match(DATE_ONLY_PATTERN)
    if (match) return match[0]

    const date = new Date(dateStr)
    if (Number.isNaN(date.getTime())) return ''

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export const formatDateOnly = (
    dateStr: string | null | undefined,
    locale?: string | string[],
    options?: Intl.DateTimeFormatOptions,
    fallback = 'N/A'
): string => {
    const dateInputValue = toDateInputValue(dateStr)
    if (!dateInputValue) return fallback

    const [year, month, day] = dateInputValue.split('-').map(Number)
    return new Date(year, month - 1, day).toLocaleDateString(locale, options)
}
